import { useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { X } from "lucide-react";

const galleryImages = [
  {
    id: 1,
    src: "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=600",
    alt: "Salão de beleza moderno",
    category: "Ambiente",
  },
  {
    id: 2,
    src: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=600",
    alt: "Corte de cabelo feminino",
    category: "Cortes",
  },
  {
    id: 3,
    src: "https://images.unsplash.com/photo-1595476108010-b4d1f102b1b1?w=600",
    alt: "Coloração profissional",
    category: "Coloração",
  },
  {
    id: 4,
    src: "https://images.unsplash.com/photo-1604654894610-df63bc536371?w=600",
    alt: "Manicure",
    category: "Unhas",
  },
  {
    id: 5,
    src: "https://images.unsplash.com/photo-1559599101-f09722fb4948?w=600",
    alt: "Tratamento capilar",
    category: "Tratamentos",
  },
  {
    id: 6,
    src: "https://images.unsplash.com/photo-1633681926022-84c23e8cb2d6?w=600",
    alt: "Maquiagem profissional",
    category: "Maquiagem",
  },
];

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section id="galeria" className="py-5 bg-muted">
      <Container className="py-5">
        <div className="text-center mb-5">
          <span className="d-inline-block text-primary-custom fw-semibold mb-3">
            Nosso Trabalho
          </span>
          <h2 className="display-6 fw-bold mb-3">Galeria de Fotos</h2>
          <p className="text-muted-custom mx-auto" style={{ maxWidth: "600px" }}>
            Conheça nossos trabalhos e inspire-se para sua próxima transformação.
          </p>
        </div>

        <Row className="g-4">
          {galleryImages.map((image, index) => (
            <Col key={image.id} sm={6} md={4}>
              <div
                className="gallery-item rounded-4 overflow-hidden position-relative"
                style={{
                  cursor: "pointer",
                  animationDelay: `${index * 0.1}s`,
                }}
                onClick={() => setSelectedImage(image)}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-100 h-100 object-fit-cover"
                  style={{ aspectRatio: "1/1" }}
                />
                <div className="gallery-overlay position-absolute inset-0 d-flex flex-column align-items-center justify-content-center text-white p-3">
                  <span className="badge bg-white text-dark mb-2">{image.category}</span>
                  <p className="small mb-0 text-center">{image.alt}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Modal for full image view */}
      <Modal
        show={!!selectedImage}
        onHide={() => setSelectedImage(null)}
        centered
        size="lg"
        contentClassName="bg-transparent border-0"
      >
        <div className="position-relative">
          <button
            className="btn btn-light rounded-circle position-absolute top-0 end-0 m-3 shadow"
            onClick={() => setSelectedImage(null)}
            style={{ zIndex: 1, width: "40px", height: "40px" }}
          >
            <X size={20} />
          </button>
          {selectedImage && (
            <img
              src={selectedImage.src.replace("w=600", "w=1200")}
              alt={selectedImage.alt}
              className="w-100 rounded-4"
            />
          )}
        </div>
      </Modal>
    </section>
  );
};

export default GallerySection;